import React from "react";
import styled from "styled-components";

import SectionWrapper from '../UI/SectionWrapper';

import { COLORS } from "../../../Constants/colors";
import aboutUs from "../../../Assets/about-us.jpg";

const Section = styled.section`
  display: flex;
  width: 100%;
  min-height: 700px;
  overflow: hidden;
  background-color: ${COLORS?.cardBackground};
  align-items: stretch;
  border-radius: 12px;

  @media (max-width: 1250px) {
    flex-direction: column;
    height: auto;
  }
`;

const ImageSection = styled.div`
  flex: 4.5;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
      clip-path: polygon(0 0, 80% 0, 100% 20%, 100% 100%, 0% 100%);

  }

  @media (max-width: 1200px) {
    height: 300px;
    img {
      height: 600px;
    }
  }
`;

const ContentSection = styled.div`
  flex: 5.5;
  padding: 0rem 3rem 1rem 3rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: ${COLORS.cardBackground};
  color: ${COLORS?.textPrimary};

  @media (max-width: 1200px) {
    padding: 2rem 1.5rem;
  }

  h2 {
    color: ${COLORS?.primary};
    font-size: 1.3rem;
    margin-bottom: 0rem;
  }

  p {
    font-size: 1.2rem;
    line-height: 1.8;
    margin-bottom: 0rem;
  }
`;


const AboutSection = () => {
  return (
    <SectionWrapper heading={"ABOUT US"}>
        <Section>
        <ImageSection>
            <img src={aboutUs} alt="About Us"/>
        </ImageSection>
        <ContentSection>
            <p>
            Our team comprises of highly skilled professionals with extensive experience in supporting a wide range of applications across various industries. We stay updated with the latest technologies and industry trends to deliver the best solutions. We look forward to partnering and helping you achieve your business objectives.
            </p>
            <h2>Who We Are</h2>
            <p>
            With an average of 20+ years of industry experience, our leadership team has worked with leading MNCs including HP (USA), Xerox (USA), Pearson (USA), RM Plc (UK), Schneider Electric (France), Goodpack IBC (Singapore) and more.
            </p>
            <p>
            Since our inception in 2021, we have been on a remarkable journey of growth and accomplishment. We started with a vision to revolutionize the IT landscape by providing cutting-edge solutions that empower our clients to achieve their goals.
            </p>
            <p>
            We have honed our skills, expanded our team, and forged strong partnerships, allowing us to deliver exceptional value to our customers. With a strong foundation built on expertise, innovation, and client satisfaction, we have been serving businesses and HNI(High Networth Individual) clients with top-notch IT solutions that drive success.
            </p>
        </ContentSection>
        </Section>
    </SectionWrapper>
  );
};

export default AboutSection;